import ViolationsTabDetailsConflicts from './ViolationsTabDetailsConflicts';

export default ViolationsTabDetailsConflicts;
